
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Bookpunetogoacabtaxi() {



    const cardData =
    {
        keyword: 'Pune to Goa Taxi Services',
        heading: 'S9 Travels: Pune to Goa Taxi Services',
        headingDescription: 'S9 Travels offers reliable, comfortable, and affordable taxi services from Pune to Goa. Whether you are heading for a beach vacation, a relaxing holiday, or a cultural getaway, our well-maintained fleet and professional drivers ensure a smooth and hassle-free journey. Goa is approximately 450 km from Pune, and the journey takes around 8 to 9 hours by road. Enjoy a safe, comfortable ride with our top-notch amenities and customer-centric service.',

        top: 'Top Places to Visit in Goa with S9 Travels',

"topPlaces": [
    {
        "title": "Baga Beach",
        "description": "One of the most popular beaches in Goa, Baga Beach is famous for its vibrant atmosphere, water sports, and lively beach shacks. Visitors can enjoy parasailing, jet skiing, and relaxing by the beach with a drink in hand. It’s an ideal destination for both adventure seekers and those looking to unwind."
    },
    {
        "title": "Calangute Beach",
        "description": "Known as the 'Queen of Beaches,' Calangute Beach is a must-visit in Goa. It’s one of the largest and busiest beaches, offering a wide variety of water sports and a bustling atmosphere. The beach is lined with shops, restaurants, and bars, making it a popular spot for tourists."
    },
    {
        "title": "Anjuna Beach",
        "description": "Anjuna Beach is famous for its laid-back vibe, vibrant nightlife, and beautiful scenery. The beach is known for its iconic Wednesday flea market, where visitors can shop for unique items. Anjuna also has a rich history with its trance parties and hippie culture."
    },
    {
        "title": "Fort Aguada",
        "description": "A historical gem, Fort Aguada is a 17th-century Portuguese fort offering breathtaking views of the Arabian Sea. It’s one of the most well-preserved forts in Goa, and visitors can explore the fort's watchtower, lighthouse, and surrounding areas while learning about Goa's colonial past."
    },
    {
        "title": "Dudhsagar Waterfalls",
        "description": "Located on the border between Goa and Karnataka, Dudhsagar Waterfalls is one of the tallest waterfalls in India. The majestic falls, surrounded by lush green forests, create a stunning spectacle, especially during the monsoon season. It’s a must-visit for nature lovers and adventure enthusiasts."
    },
    {
        "title": "Basilica of Bom Jesus",
        "description": "A UNESCO World Heritage Site, the Basilica of Bom Jesus is one of the oldest churches in India. Located in Old Goa, it houses the mortal remains of St. Francis Xavier. The church’s stunning baroque architecture and historical significance make it a must-visit for history and culture enthusiasts."
    },
    {
        "title": "Se Cathedral",
        "description": "Also located in Old Goa, Se Cathedral is one of the largest churches in Asia and is known for its beautiful Portuguese-Gothic architecture. The church is dedicated to St. Catherine and is a significant religious site in Goa."
    },
    {
        "title": "Palolem Beach",
        "description": "Known for its peaceful environment and palm-fringed coastline, Palolem Beach is ideal for those looking to escape the crowds. The beach offers a tranquil setting, perfect for relaxing, kayaking, and enjoying the beauty of Goa’s southern coastline."
    },
    {
        "title": "Chapora Fort",
        "description": "Famous for its appearance in the Bollywood movie Dil Chahta Hai, Chapora Fort offers stunning panoramic views of the Arabian Sea and the surrounding coastline. The fort's ruins and scenic beauty make it a popular spot for tourists and photographers."
    },
    {
        "title": "Cotigao Wildlife Sanctuary",
        "description": "For nature and wildlife enthusiasts, Cotigao Wildlife Sanctuary is a beautiful destination. It’s the second-largest wildlife sanctuary in Goa and is home to a variety of flora and fauna, including rare species. The sanctuary offers walking trails, nature walks, and bird watching, providing a perfect escape into nature."
    }
],

"services": [
  {
    "name": "Pune to Goa Taxi",
    "description": "S9 Travels offers comfortable and reliable taxi services for your journey from Pune to Goa. Whether you're traveling for leisure, vacation, or business, enjoy a smooth and hassle-free ride. Book your Pune to Goa taxi today!"
  },
  {
    "name": "Pune to Goa Cab Booking",
    "description": "Booking a cab from Pune to Goa is easy with S9 Travels. Whether you prefer to book online or over the phone, we offer flexible booking options to make your journey as convenient as possible. Book your ride today!"
  },
  {
    "name": "Pune to Goa Taxi Service",
    "description": "Choose S9 Travels for a professional and reliable taxi service from Pune to Goa. Our experienced drivers and well-maintained vehicles guarantee a comfortable, safe, and enjoyable journey."
  },
  {
    "name": "Pune to Goa One-Way Taxi",
    "description": "S9 Travels offers affordable and convenient one-way taxi services from Pune to Goa. Whether you’re planning a quick getaway or a relaxing vacation, we ensure a direct and comfortable ride to your destination."
  },
  {
    "name": "Pune to Goa Round Trip",
    "description": "For a round trip from Pune to Goa, S9 Travels offers flexible and hassle-free options. We ensure that your journey is comfortable, timely, and convenient, with professional drivers to make your round trip enjoyable."
  },
  {
    "name": "Pune to Goa Cab Fare",
    "description": "S9 Travels provides transparent and affordable cab fares for your Pune to Goa journey. We ensure you get the best value without hidden charges. Contact us for an accurate fare estimate for your trip."
  },
  {
    "name": "Pune to Goa Car Rental",
    "description": "Looking to rent a car for your trip from Pune to Goa? S9 Travels offers flexible car rental services, allowing you to travel at your own pace. Choose from a variety of vehicles that best suit your travel needs and preferences."
  },
  {
    "name": "Pune to Goa Luxury Taxi",
    "description": "For a premium and luxurious travel experience, S9 Travels offers luxury taxi services from Pune to Goa. Enjoy a smooth, comfortable ride with enhanced features and extra space for a truly relaxed journey."
  },
  {
    "name": "Pune to Goa Efficient Taxi",
    "description": "S9 Travels provides Efficient Taxi services for those seeking a more budget-friendly travel option. Share the ride with others while still enjoying a comfortable and convenient taxi experience from Pune to Goa."
  },
  {
    "name": "Pune to Goa Private Taxi",
    "description": "For a personalized and exclusive travel experience, S9 Travels offers private taxi services from Pune to Goa. Enjoy the privacy and flexibility of traveling at your own pace with a dedicated driver and high-quality vehicle."
  }
],


"tableData": [
  ["Book Pune To Goa Taxi", "Book Pune To Goa Cab Booking"],
  ["Book Pune To Goa Taxi Service", "Book Pune To Goa One-Way Taxi"],
  ["Book Pune To Goa Round Trip", "Book Pune To Goa Cab Fare"],
  ["Book Pune To Goa Car Rental", "Book Pune To Goa Luxury Taxi"],
  ["Book Pune To Goa Efficient Taxi", "Book Pune To Goa Private Taxi"]
],
"whychoose": [
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "At S9 Travels, we understand the importance of time when traveling from Pune to Goa. Whether you're heading for a beach vacation, a family getaway, or a business trip, our drivers ensure timely pickups and drop-offs, so your trip is stress-free and enjoyable."
  },
  {
    "WhyChooseheading": "Comfortable and Spacious Vehicles",
    "WhyChoosedescription": "We offer a fleet of well-maintained, comfortable vehicles for your journey to Goa. With spacious interiors, air conditioning, and plush seating, we ensure you enjoy a smooth and relaxing ride during your trip."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our drivers are experienced professionals who know the best routes from Pune to Goa. They prioritize your safety and comfort, ensuring a smooth, safe, and pleasant ride throughout the journey."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers competitive, affordable pricing for your Pune to Goa trip. With no hidden charges and a clear breakdown of costs upfront, you know exactly what to expect for your journey."
  },
  {
    "WhyChooseheading": "Safe and Comfortable Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features such as airbags, seat belts, and GPS tracking, ensuring a secure and comfortable ride from Pune to Goa."
  },
  {
    "WhyChooseheading": "24/7 Availability",
    "WhyChoosedescription": "S9 Travels operates 24/7, allowing you to book your cab at any time, whether it’s an early morning departure or a late-night return. Our customer service team is always available to assist you with your travel needs."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Booking your Pune to Goa cab with S9 Travels is quick and easy. You can book through our website or mobile app, or reach out to our customer service team for personalized booking assistance."
  },
  {
    "WhyChooseheading": "Customized Travel Packages",
    "WhyChoosedescription": "Whether you're visiting Goa for relaxation, sightseeing, or business, we offer customized travel packages that can be tailored to your needs. Let us know your preferences, and we’ll ensure your trip is memorable and seamless."
  }
]











    }




    const faqData = [
        [
          {
            question: 'How can I book a Pune to Goa cab with S9 Travels?',
            answer: 'Booking is simple! You can reserve your cab via our website, mobile app, or contact our customer service team for personalized assistance.',
          },
          {
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are highly experienced and familiar with the best routes to Goa, ensuring a safe and smooth journey.',
          },
          {
            question: 'What types of vehicles are available for Pune to Goa travel?',
            answer: 'We offer a variety of vehicles including sedans, SUVs, and premium cars, all designed for comfort on long journeys.',
          },
          {
            question: 'How do I pay for my Pune to Goa cab rental?',
            answer: 'We offer flexible payment options, including cash, credit/debit cards, and online payments via our app, so you can choose the most convenient method for you.',
          },
          {
            question: 'Can I book a round trip from Pune to Goa?',
            answer: 'Yes, we offer round-trip services. Provide us with your return details, and we’ll ensure your trip is well-coordinated for a seamless experience.',
          },
          {
            question: 'Are there any extra charges for waiting or detours?',
            answer: 'If there are any additional charges, such as for waiting time or detours, we will communicate them to you upfront, ensuring complete transparency in pricing.',
          },
          {
            question: 'Can I hire a cab for sightseeing in Goa?',
            answer: 'Yes, we offer sightseeing tours in Goa. Explore the beautiful beaches, historical sites, and vibrant local attractions with our experienced drivers.',
          },
          {
            question: 'What is the luggage allowance for a Pune to Goa cab?',
            answer: 'Our vehicles can comfortably accommodate standard luggage. If you have more luggage or specific requirements, please inform us during the booking process, and we’ll make the necessary arrangements.',
          },
          {
            question: 'Is S9 Travels available for corporate travel between Pune and Goa?',
            answer: 'Yes, we provide corporate travel services for business trips, group travel, or team outings between Pune and Goa.',
          },
          {
            question: 'Why should I choose S9 Travels for Pune to Goa travel?',
            answer: 'S9 Travels ensures a comfortable, reliable, and affordable journey. With professional drivers, well-maintained vehicles, and excellent customer service, we guarantee a safe and smooth trip every time.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Anil Rao',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“I had an excellent experience with S9 Travels on my trip to Goa. The vehicle was clean and comfortable, and the driver was courteous and professional. I’ll definitely book with them again for my future travels!”',
        },
        {
          name: 'Mrs. Neha Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],  
          text: '“Our family trip to Goa was made much easier with S9 Travels. The vehicle was spacious, and the driver was very helpful and knowledgeable. We had a pleasant and relaxed journey. Highly recommended!”',
        },
      ];
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   
    const productSchema = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Book Pune To Goa Cab Taxi",
        "description": "Book Pune To Goa taxi services, one-way taxi, round trip, luxury taxi, Efficient Taxi, private taxi, and car rental with S9 Travels. Enjoy affordable fares for Pune to Goa cab booking with safe, comfortable, and reliable taxi services for your journey to Goa.",
        "aggregateRating": {
          "@type": "AggregateRating",
          "bestRating": "5",
          "worstRating": "1",
          "ratingValue": "4.8",
          "ratingCount": "8569"
        }
      };
      
     
      
      
      


    return (
        <div>
          <Helmet>
        <title>Book Pune To Goa Cab Taxi | Contact: +91 8850328441</title>
        <meta 
          name="description" 
          content="Book Pune To Goa taxi services, one-way taxi, round trip, luxury taxi, Efficient Taxi, private taxi, and car rental with S9 Travels. Get the best fares for Pune to Goa cab booking and enjoy a comfortable and safe journey to Goa." 
        />
        
        {/* Inject JSON-LD Schema */}
        <script type="application/ld+json">
          {JSON.stringify(productSchema)}
        </script>
      </Helmet>
<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/5.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bookpunetogoacabtaxi;